<template>
   <div class="table_main">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteTableMain()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">{{Model.forms.addTableMain.title}}</div>
            <div class="subtitle">{{Model.forms.addTableMain.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="Model.forms.addTableMain.name" 
                  :forms="Model.forms.addTableMain.forms" 
                  :form_data="Model.forms.addTableMain.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="addTableMain({ref: $refs[Model.forms.addTableMain.name]})" :disabled="loading">
                     Create <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{Model.forms.editTableMain.title}}</div>
            <div class="subtitle">{{Model.forms.editTableMain.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="Model.forms.editTableMain.name" 
                  :forms="Model.forms.editTableMain.forms" 
                  :form_data="Model.forms.editTableMain.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="updateTableMain({ref: $refs[Model.forms.editTableMain.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add TableMain <i class="fa fa-plus"></i>
         </div>
      </div>
      
      <Table v-bind="Model.tables.table_main.props" :data="table_mains" @on-action="handleActions"/>
   </div>
</template>

<script>
import table_main from "./table_main.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('table_main')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('table_main',table_main,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   computed: {
      ...mapGetters([
         'Model',
         'table_mains',
         'show_create_modal',
         'show_edit_modal',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'addTableMain',
         'deleteTableMain',
         'updateTableMain',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('table_main',table_main,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .table_main{
      
   }
</style>